module.exports = __webpack_public_path__ + "static/media/youshallnotpass.85cc6e4f.png";